/**
 * Download grid & PDP Software tab: swatches swap card image and sync ?variant= on
 * links to product-download articles and product pages (matches product-download-module).
 */

function downloadVariantShouldAttachToUrl(href) {
  try {
    const u = new URL(href, window.location.origin);
    if (u.protocol !== "http:" && u.protocol !== "https:") return false;
    if (u.origin !== window.location.origin) return false;
    const p = u.pathname.toLowerCase();
    if (/\.(zip|pdf|rar|7z|exe|dmg|pkg|doc|docx|xls|xlsx|msi)(\?|$)/i.test(p)) return false;
    if (p.includes("/products/")) return true;
    if (p.includes("/blogs/product-download")) return true;
    return false;
  } catch (_e) {
    return false;
  }
}

function downloadHrefWithVariant(href, variantId) {
  if (!variantId || !downloadVariantShouldAttachToUrl(href)) return href;
  try {
    const u = new URL(href, window.location.origin);
    u.searchParams.set("variant", String(variantId));
    return u.pathname + u.search + u.hash;
  } catch (_e) {
    return href;
  }
}

function syncDownloadLinks(productItem, variantId) {
  if (!productItem || !variantId) return;

  const scope =
    productItem.closest("[data-download-category-product-item]") ||
    productItem.closest(".software-download-product-card") ||
    productItem.closest(".view-download");

  const wrapAnchor = productItem.closest("a[href]");
  if (wrapAnchor) {
    const href = wrapAnchor.getAttribute("href");
    const next = downloadHrefWithVariant(href, variantId);
    if (next !== href) wrapAnchor.setAttribute("href", next);
  }

  if (!scope) return;

  scope.querySelectorAll("a[href]").forEach((a) => {
    const href = a.getAttribute("href");
    if (!href || href.startsWith("#")) return;
    const next = downloadHrefWithVariant(href, variantId);
    if (next !== href) a.setAttribute("href", next);
  });
}

/** Call after injecting download card HTML (e.g. PDP fetch); root is .view-download or li.download-item */
function syncDownloadCardVariantLinks(root) {
  if (!root || !root.querySelector) return;
  const item = root.querySelector(".download-category__product-item");
  const active = root.querySelector(".download-static-variants .color-btn.active");
  if (!item || !active) return;
  const vid = active.getAttribute("data-variant-id");
  if (vid) syncDownloadLinks(item, vid);
}

window.syncDownloadCardVariantLinks = syncDownloadCardVariantLinks;

function isPdpSwatchContext(dot) {
  return !!(dot.closest(".view-download") || dot.closest(".software-download-product-card"));
}

function handleSwatchClick(dot) {
  const imageUrl = dot.getAttribute("data-variant-image");
  const variantId = dot.getAttribute("data-variant-id");
  const productItem = dot.closest(".download-category__product-item");
  if (!imageUrl || !productItem) return;

  const imageEl = productItem.querySelector(".download-category__product-image img");
  if (!imageEl) return;

  imageEl.setAttribute("src", imageUrl);
  imageEl.setAttribute("data-src", imageUrl);
  imageEl.setAttribute("srcset", imageUrl);

  const dots = dot.parentElement ? dot.parentElement.querySelectorAll(".color-btn") : [];
  dots.forEach((item) => item.classList.remove("active"));
  dot.classList.add("active");

  syncDownloadLinks(productItem, variantId);
}

/** PDP: capture phase stops bubbling before card/list click handlers */
document.addEventListener(
  "click",
  function (event) {
    const dot = event.target.closest(".download-static-variants .color-btn");
    if (!dot || !isPdpSwatchContext(dot)) return;

    event.preventDefault();
    event.stopPropagation();
    handleSwatchClick(dot);
  },
  true
);

/** /pages/software grid: original bubble handler (unchanged behavior) */
document.addEventListener("click", function (event) {
  const dot = event.target.closest(".download-static-variants .color-btn");
  if (!dot || isPdpSwatchContext(dot)) return;

  event.preventDefault();
  event.stopPropagation();
  handleSwatchClick(dot);
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-download-category-product-item]").forEach((scope) => {
    syncDownloadCardVariantLinks(scope);
  });
});
